<template>
  <div class="row">
    <div class="col-md-12">
      <h6 class="upper-text">Período de validação da prescrição</h6>
    </div>
    <div class="col-md-6">
      <label>DATA DE INÍCIO</label>
      <input
        disabled
        :value="formatDateToUs(start_date)"
        type="date"
        class="form-control"
      />
    </div>
    <div class="col-md-6">
      <label>DATA DE TÉRMINO</label>
      <input
        disabled
        :value="formatDateToUs(end_date)"
        type="date"
        class="form-control"
      />
    </div>
    <div class="col-md-12">
      <ErrorsMessages :errors="errors" />
    </div>
    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-text-right"
    >
      <confirmation-dialog
        certificate
        headerClass="modal-header-ok"
        message-title="CONFIRMAÇÃO"
        message-body="Deseja realmente finalizar a prescrição?"
        open-class="btn-notcertified"
        open-left-icon="fa-check"
        open-text="FINALIZAR MANUAL COM ASSINATURA ELETRÔNICA"
        :loading="loading"
        :disabled="loading"
        @yes="finish"
      />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import ConfirmationDialog from "../../../templates/Components/ConfirmationDialog";

import api from "../../../services/api";

import { formatDateToUs } from "../../../lib/format";

import BRyHUB from "../../../lib/BRy/hub";

export default {
  name: "Medicine",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
  },

  props: {
    id: [String, Number],
    start_date: String,
    end_date: String,
  },

  data() {
    return {
      loading: false,

      errors: [],
    };
  },

  methods: {
    formatDateToUs,

    async finish() {
      try {
        this.loading = true;

        const { id } = this;

        var params = { id };

        const response = await api.put(
          "/rest-home/finish/group-prescription-medicine",
          params
        );

        const { error, errors } = response.data;

        if (!error) {
          this.$emit("finish");

          await BRyHUB.authorize({ id, table: "group_prescription_medicine" });
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
